import { Injectable } from '@angular/core';

@Injectable({providedIn:"root"})
export class LocalService {

  constructor() { }


  setObject(key,obj){
    localStorage.setItem(key,JSON.stringify(obj));
  }
  getObject(key){
    return JSON.parse(localStorage.getItem(key));
  }
  setString(key,str){
    localStorage.setItem(key,str);
  }

  getString(key){
    return localStorage.getItem(key);
  }

  removeString(key){
    localStorage.removeItem(key)
  }
  removeObject(key){
    localStorage.removeItem(key)
  }
  setCookies(name,value,day){
    if (day) {
        let date:any = new Date();
        date.setTime(date.getTime()+(day*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
  }
  getCookies(){
    return document.cookie;
  }
  deleteCookies(name:string){
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  
}
